// A player's view of their own games, shared by the game list (SPEC §4.4) and the nav bar's game
// chips (SPEC §4.3; plan 2026-11-04-navigation-return.md).
import { seats } from './players';

// Whether the game waits for the player: their move, or, while a move is sealed, a request to
// resume or agreeing to the other's (plan 2026-10-29-sealed-moves.md); the player who has asked waits.
export function isMyMove(g, me) {
  if(!me || g.status !== 'in-progress' || !g.nextStone) return false;
  if(g.seal) return (!g.seal.request || g.seal.request.by !== me.id) && (g.players || []).some(p => p.id === me.id);
  const player = seats(g)[g.nextStone];
  return !!player && player.id === me.id;
}

// The other player of one of my games, with their colour; "you" when I play both.
export function opponent(g, me) {
  const s = seats(g);
  const id = me && me.id;
  if(s.black && s.white && s.black.id === id && s.white.id === id) return { colour: 'white', player: s.white, you: true };
  if(s.black && s.black.id === id) return { colour: 'white', player: s.white };
  return { colour: 'black', player: s.black };
}

// The time of the game's last record (or its creation).
export function lastTime(g) {
  return new Date(g.lastMoveAt || g.createdAt || 0).getTime();
}

// When the game ended: completedAt, or for games ended before it was written, the last record.
export function finishTime(g) {
  const done = g.completedAt && !g.completedAt.startsWith('0001') ? g.completedAt : null;
  return new Date(done || g.lastMoveAt || g.createdAt || 0).getTime();
}

// Sorted by the last record's time: order 1 oldest first, -1 newest first.
export function byTime(list, order) {
  return list.slice().sort((a, b) => order * (lastTime(a) - lastTime(b)) || b.id - a.id);
}

// 'won' or 'lost' for the player of a finished game; null without a winner or when they play both.
export function resultFor(g, me) {
  if(!me || !g.winner) return null;
  const s = seats(g);
  const winner = s[g.winner];
  if(!winner || (s.black && s.white && s.black.id === s.white.id)) return null;
  return winner.id === me.id ? 'won' : 'lost';
}
